module.exports = "<p>\n  get-help works!\n</p>\n"